import { Button } from './../../../layout/Button';
import { IconPlus } from '../../../icons/IconPlus';
import { IconMinus } from '../../../icons/IconMinus';

export type QuantityInputProps = {
  qty: number;
  incrementQty: () => void;
  decrementQty: () => void;
  disabled: boolean;
};

export const QuantityInput = ({
  qty,
  incrementQty,
  decrementQty,
  disabled,
}: QuantityInputProps) => {
  return (
    <div
      className="border-border-neutral text-neutral flex rounded border"
      data-testid="quantity-input"
    >
      <Button
        className="bg-white px-2"
        variant="invisible"
        onClick={decrementQty}
        disabled={qty <= 1 || disabled}
        data-testid="subtract-quantity"
      >
        <IconMinus className="text-neutral" />
      </Button>
      <div
        className="min-w-[20px] self-center text-center text-base font-semibold leading-normal"
        data-testid="quantity"
        style={disabled ? { opacity: 0.5 } : { opacity: 1 }}
      >
        {qty}
      </div>
      <Button
        className="bg-white px-2"
        variant="invisible"
        onClick={incrementQty}
        disabled={qty >= 9 || disabled}
        data-testid="add-quantity"
      >
        <IconPlus className="text-neutral" />
      </Button>
    </div>
  );
};
